import { useRef } from 'react'
import { ITimeline } from '../timeline/types'
import SupervisorModule from './Module'

const useOpenEndedLogger = (timeline: ITimeline, target: string) => {
  const stateRef = useRef<{
    lastArgs: { timeline: ITimeline; target: string }
    lastEdit: Record<string, { length: number; timestamp: number; changes: number }>
    onOpenEndedChange: (value: string, ref?: string, doLog?: boolean) => void
  }>()

  if (null == stateRef.current) {
    stateRef.current = {
      lastArgs: { timeline, target },
      lastEdit: {},
      onOpenEndedChange: null
    }
  }

  if (
    null == stateRef.current.onOpenEndedChange ||
    stateRef.current.lastArgs.timeline !== timeline ||
    stateRef.current.lastArgs.target !== target
  ) {
    stateRef.current.lastArgs = { timeline, target }

    stateRef.current.onOpenEndedChange = (value, ref = target, doLog = true) => {
      if (!SupervisorModule.options.openEndedLogger.enabled) {
        return
      }

      if (null == stateRef.current.lastEdit[ref]) {
        stateRef.current.lastEdit[ref] = { length: 0, timestamp: null, changes: 0 }
      }

      const lastEdit = stateRef.current.lastEdit[ref]

      const currentTimestamp = Date.now()
      if (null == lastEdit.timestamp) {
        lastEdit.timestamp = currentTimestamp
      }

      const valueLength = value?.length || 0
      const editLength = Math.max(0, valueLength - lastEdit.length)
      lastEdit.length = valueLength

      lastEdit.changes += editLength

      if (SupervisorModule.options.openEndedLogger.trigger <= lastEdit.changes) {
        if (doLog) {
          timeline.log({
            type: SupervisorModule.options.openEndedLogger.eventType,
            ref,
            target,
            context: { changes: lastEdit.changes, value: value }
          })
        }
        lastEdit.timestamp = null
        lastEdit.changes = 0
      } else if (SupervisorModule.options.openEndedLogger.intervalMs < currentTimestamp - lastEdit.timestamp) {
        lastEdit.timestamp = currentTimestamp
        lastEdit.changes = editLength
      }
    }
  }

  return stateRef.current.onOpenEndedChange
}

export default useOpenEndedLogger
